<template>
  <Teleport to="body" :disabled="!isScreen">
    <div
      class="w-full py-[30px] shrink-0"
      :class="
        isScreen ? 'fixed z-[9999] h-screen w-screen bg-[#00000088] top-0 left-0' : 'relative'
      "
    >
      <div
        class="w-[max-content] h-[max-content] absolute left-0 right-0 top-0 bottom-0 m-auto flex items-center justify-center"
      >
        <svg width="20px" height="20px" viewBox="0 0 20 20" class="e-loading-10">
          <circle cx="10" cy="10" r="8" stroke-width="3" fill="none"></circle>
          <circle
            cx="10"
            cy="10"
            r="8"
            stroke-width="3"
            fill="none"
            stroke-linecap="round"
            stroke-dasharray="50.26548245743669"
            stroke-dashoffset="1.5079644737230993"
            class="spinner-circle"
          ></circle>
        </svg>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
defineProps({
  isScreen: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped>
.e-loading-10 > circle:first-of-type {
  stroke: #2dee8866;
}

.e-loading-10 > circle:last-of-type {
  stroke: #2dee88;
}

.spinner-circle {
  animation: spinner-dashoffset 1s linear infinite;
}

@keyframes spinner-dashoffset {
  0% {
    stroke-dashoffset: 60;
  }
  100% {
    stroke-dashoffset: 1;
  }
}
</style>
